export default {
    beforeMount(el) {
        // 禁止浏览器显示历史输入记录
        el.setAttribute('autocomplete', 'off');

        el.addEventListener('input', function (event) {
            // 获取当前输入值
            let value = event.target.value;
            // 替换多个连续空格为单个空格
            value = value.replace(/\s+/g, ' ');

            // 如果值有改变，更新 input 并触发 v-model 更新
            if (event.target.value !== value) {
                event.target.value = value;
                // 手动触发 input 事件，确保 v-model 同步
                const inputEvent = new Event('input', { bubbles: true });
                event.target.dispatchEvent(inputEvent);
            }
        });
        el.addEventListener('blur', function (event) {
            // 获取当前输入值
            let value = event.target.value;

            // 去除输入框内容的前后空格
            value = value.trim();

            // 如果值有改变，更新 input 并触发 v-model 更新
            if (event.target.value !== value) {
                event.target.value = value;
                // 手动触发 input 事件，确保 v-model 同步
                const inputEvent = new Event('input', { bubbles: true });
                event.target.dispatchEvent(inputEvent);
            }
        });
    }
};
